/**
 * Returns whether a hostname belongs to the pwiworks.app production domain.
 */
export function isPwiworksAppHost(hostname: string): boolean {
  const normalizedHostname = hostname.toLowerCase();
  return normalizedHostname === 'pwiworks.app' || normalizedHostname.endsWith('.pwiworks.app');
}
